import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import { divVariants, fadeVariants } from "shared/components/animations";
import FlusterPlayerList from "../components/FlusterPlayerList";
import FlusterCard from "../components/FlusterCard";

const FLUSAsker = ({
  otherPlayers,
  askerPlayer,
  roomId,
  isAskerPlayer,
  currentPlayerCard,
  screens
}) => {
  const other_player_info = _.get(
    screens,
    "answerer.2_asker.info_2",
    " It's not your turn yet."
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="flus-asker"
    >
      {isAskerPlayer ? (
        <>
          <FlusterPlayerList
            users={otherPlayers}
            roomId={roomId}
            askerPlayer={askerPlayer}
            isAskerPlayer={isAskerPlayer}
            socketCall={true}
          />
        </>
      ) : (
        <>
          <div className="question-card-main">
            <motion.h4
              variants={fadeVariants}
              className="question-card-heading"
            >
              {other_player_info}
            </motion.h4>
            <div className="fluster-card-container">
              {currentPlayerCard?.cards.map((card, index) => (
                <FlusterCard card={card} key={index} />
              ))}
            </div>
          </div>
        </>
      )}
    </motion.div>
  );
};

export default FLUSAsker;
